/**
 * Javascript file for the initialization of Vuetify.
 * @author Yannik Sprengart
 */

// src/plugins/vuetify.js

import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#9A2A28",
        secondary: "#212121",
        accent: "#8c9eff",
        error: "#b71c1c"
      }
    }
  }
});

Vue.use(Vuetify);

const opts = {};

export default new Vuetify(opts);



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js